var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 268.4 268.4",
    style: {
      enableBackground: "new 0 0 268.4 268.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.1,41.9L87.8,42c0,0-20,0.5-34.6,16.2c0,0-53.2,68.7-53.2,87.2v67.1c0,14.3,14,13.9,14,13.9h222.7   c9,0,23.4,0.9,28-4.5c2.1-2.5,3.7-6.3,3.7-12.2v-67.1c0-18.5-51.7-83.9-51.7-83.9S203,41.9,183.1,41.9z M168.3,158.3   c0,0,0,17.9-16.8,17.9h-35.1c-5.8,0-9.7-1.4-12.2-3.3c-5.6-4.3-3.7-18.7-8.9-24.5c-5-5.7-12.5-5.7-12.5-5.7h-35   c-9,0-12.8-6.4-8.4-14.3l29.9-53.9c0,0,9-15.9,17.9-15.7h80.6c9,0,20.9,2.3,25.2,6.8c2.2,2.3,4.6,5.2,6.8,8.9l28.4,53.7   c4.2,8,0.3,14.4-8.7,14.4H185C169.3,142.6,168.3,158.3,168.3,158.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.27b5a8dd7744323f39f24d50ab69e28f.svg";
export { ForwardRef as ReactComponent };